import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "text-negative" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_iuf_select = _resolveComponent("iuf-select")!
  const _component_brief_group_select = _resolveComponent("brief-group-select")!
  const _component_q_step = _resolveComponent("q-step")!
  const _component_q_stepper = _resolveComponent("q-stepper")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_dialog_skeleton = _resolveComponent("dialog-skeleton")!

  return (_openBlock(), _createBlock(_component_dialog_skeleton, {
    loading: _ctx.loading,
    title: _ctx.briefId ? _ctx.t('TITLE.UPDATE', { object: _ctx.t('BRIEF.LOW.SING') }) : _ctx.t('TITLE.CREATE', { object: _ctx.t('BRIEF.LOW.SING') }),
    "cancel-label": _ctx.useCancelLabel ? _ctx.t('ACTION.CANCEL') : _ctx.t('ACTION.BACK'),
    "confirm-label": _ctx.useConfirmLabel ? _ctx.t('ACTION.CONFIRM') : _ctx.t('ACTION.NEXT'),
    "disable-confirm": !_ctx.isTitleValid,
    onCancel: _ctx.revertStep,
    onConfirm: _ctx.nextStep,
    ref: "dialog"
  }, {
    content: _withCtx(() => [
      _createVNode(_component_q_card, { class: "bg-white" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "column q-py-none q-px-lg" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_stepper, {
                animated: "",
                color: "primary",
                contracted: "",
                flat: "",
                "header-class": "hidden",
                ref: "stepper",
                modelValue: _ctx.step,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.step) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_step, {
                    done: _ctx.step > _ctx.BriefFormSteps.IDENTIFIERS,
                    name: _ctx.BriefFormSteps.IDENTIFIERS,
                    class: "q-pb-lg",
                    title: ""
                  }, {
                    default: _withCtx(() => [
                      (!_ctx.editMode)
                        ? (_openBlock(), _createBlock(_component_q_toolbar, _normalizeProps(_mergeProps({ key: 0 }, _ctx.TEXT_QUATERNARY_TITLE)), {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('STEP_COUNT', { step: _ctx.step })) + " • " + _toDisplayString(_ctx.t(`BRIEF_CREATION_STEPS.STEP-${_ctx.step}`, { leads: _ctx.t('LEAD.LOW.PLUR') })), 1)
                            ]),
                            _: 1
                          }, 16))
                        : _createCommentVNode("", true),
                      _createVNode(_component_q_input, _mergeProps({
                        placeholder: _ctx.t('NAME.PLACEHOLDER'),
                        rules: [(val) => val.trim().length > 0 && val.trim().length <= _ctx.MAX_LENGTH.BRIEF.NAME],
                        autofocus: "",
                        class: "q-mt-sm"
                      }, _ctx.INPUT_LG, {
                        "label-slot": "",
                        modelValue: _ctx.name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event))
                      }), {
                        label: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('NAME.LABEL')) + " ", 1),
                          _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.t('MANDATORY')), 1)
                        ]),
                        error: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            name: _ctx.ICONS_NAME.WARNING_SOLID
                          }, null, 8, ["name"]),
                          _createElementVNode("span", null, _toDisplayString(_ctx.t('NAME.VALIDATION', { Brief: _ctx.t('BRIEF.CAP.SING'), x: _ctx.MAX_LENGTH.BRIEF.NAME }, _ctx.name.trim().length)), 1)
                        ]),
                        _: 1
                      }, 16, ["placeholder", "rules", "modelValue"]),
                      _createVNode(_component_iuf_select, _mergeProps({
                        label: _ctx.t('STYLE.LABEL'),
                        options: _ctx.COLOR_OPTIONS.DEFAULT,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = (element) => _ctx.selectColor(element)),
                        "option-label": "label",
                        "label-slot": "",
                        mandatory: "",
                        "selected-item-slot": ""
                      }, _ctx.SELECT_SINGLE_LG, {
                        modelValue: _ctx.selectedColor,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedColor) = $event))
                      }), {
                        hint: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            name: _ctx.ICONS_NAME.INFO_CIRCLE_SOLID
                          }, null, 8, ["name"]),
                          _createElementVNode("span", null, _toDisplayString(_ctx.t('STYLE.HINT', { brief: _ctx.t('BRIEF.LOW.SING'), leads: _ctx.t('LEAD.LOW.PLUR') })), 1)
                        ]),
                        "selected-item": _withCtx((props) => [
                          _createVNode(_component_q_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_section, { side: "" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", {
                                    class: "square",
                                    style: _normalizeStyle({ 'background-color': props.opt.value })
                                  }, null, 4)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_q_item_section, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_label, _normalizeProps(_guardReactiveProps(_ctx.TEXT_CONTENT_BODY)), {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(props.opt.label), 1)
                                    ]),
                                    _: 2
                                  }, 1040)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        option: _withCtx((props) => [
                          _createVNode(_component_q_item_section, { side: "" }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", {
                                class: "square",
                                style: _normalizeStyle({ 'background-color': props.opt.value })
                              }, null, 4)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, _mergeProps(_ctx.TEXT_CONTENT_BODY, { class: "ellipsis" }), {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(props.opt.label), 1)
                                ]),
                                _: 2
                              }, 1040)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 1
                      }, 16, ["label", "options", "modelValue"]),
                      (_ctx.customValuesBySearchKey.length)
                        ? (_openBlock(), _createBlock(_component_brief_group_select, {
                            key: 1,
                            class: "q-my-sm",
                            label: "Group",
                            "default-option": "None",
                            selected: _ctx.selectedGroup,
                            onSelect: _ctx.onSelectGroup
                          }, null, 8, ["selected", "onSelect"]))
                        : _createCommentVNode("", true),
                      (_ctx.editMode)
                        ? (_openBlock(), _createBlock(_component_iuf_select, _mergeProps({
                            key: 2,
                            options: _ctx.dealTypeOptions,
                            "option-label": "name",
                            label: _ctx.t('DEAL_TYPE.LABEL')
                          }, _ctx.SELECT_SINGLE_LG, {
                            modelValue: _ctx.selectedDealType,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedDealType) = $event))
                          }), null, 16, ["options", "label", "modelValue"]))
                        : _createCommentVNode("", true),
                      (_ctx.editMode)
                        ? (_openBlock(), _createBlock(_component_iuf_select, _mergeProps({
                            key: 3,
                            options: _ctx.templateOptions,
                            "option-label": "name",
                            label: _ctx.t('TEMPLATE.LABEL')
                          }, _ctx.SELECT_SINGLE_LG, {
                            modelValue: _ctx.selectedTemplate,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedTemplate) = $event))
                          }), null, 16, ["options", "label", "modelValue"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["done", "name"]),
                  (!_ctx.editMode)
                    ? (_openBlock(), _createBlock(_component_q_step, {
                        key: 0,
                        done: _ctx.step > _ctx.BriefFormSteps.CLASSIFICATION,
                        name: _ctx.BriefFormSteps.CLASSIFICATION,
                        class: "q-pb-lg",
                        title: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_toolbar, _normalizeProps(_guardReactiveProps(_ctx.TEXT_QUATERNARY_TITLE)), {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('STEP_COUNT', { step: _ctx.step })) + " • " + _toDisplayString(_ctx.t(`BRIEF_CREATION_STEPS.STEP-${_ctx.step}`, { leads: _ctx.t('LEAD.LOW.PLUR') })), 1)
                            ]),
                            _: 1
                          }, 16),
                          _createVNode(_component_iuf_select, _mergeProps({
                            options: _ctx.dealTypeOptions,
                            "option-label": "name",
                            label: _ctx.t('DEAL_TYPE.LABEL')
                          }, _ctx.SELECT_SINGLE_LG, {
                            modelValue: _ctx.selectedDealType,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedDealType) = $event))
                          }), null, 16, ["options", "label", "modelValue"]),
                          _createVNode(_component_iuf_select, _mergeProps({
                            options: _ctx.templateOptions,
                            "option-label": "name",
                            label: _ctx.t('TEMPLATE.LABEL')
                          }, _ctx.SELECT_SINGLE_LG, {
                            modelValue: _ctx.selectedTemplate,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedTemplate) = $event))
                          }), null, 16, ["options", "label", "modelValue"])
                        ]),
                        _: 1
                      }, 8, ["done", "name"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["loading", "title", "cancel-label", "confirm-label", "disable-confirm", "onCancel", "onConfirm"]))
}